import { Mission } from '@/domain/project/Mission';
import { Project } from '@/domain/project/Project';
import { ResearchUnit } from '@/domain/research-unit/ResearchUnit';
import { LocalDate } from '@/domain/date/LocalDate';

interface ResearchUnitDataset {
  key: string;
  acronym: string;
  title: string;
}

export interface ProjectDataSet {
  id: number;
  shortTitle: string;
  fullTitle: string;
  researchUnits: ResearchUnitDataset[];
  thematics: number[];
  startDate: string;
  endDate: string;
  description: string;
  url: string;
  referent: string;
  missions: string[];
  partners: string;
  funders: string;
}

const MISSION_TEXT = {
  [Mission.DIFFUSION]: 'Diffusion',
  [Mission.COLLECTIONS]: 'Collections',
  [Mission.RECHERCHE]: 'Recherche',
  [Mission.ENSEIGNEMENT]: 'Enseignement',
  [Mission.EXPERTISE]: 'Expertise',
};

const toResearchUnitDataset = (researchUnit: ResearchUnit): ResearchUnitDataset => ({
  key: researchUnit.id.toString(),
  acronym: researchUnit.acronym,
  title: researchUnit.name,
});

const toReadableDate = (date?: LocalDate) => (!date ? '-' : date.toHuman());

export const toProjectDataSet = (project: Project, researchUnits: ResearchUnit[]): ProjectDataSet => ({
  id: project.id,
  shortTitle: project.shortTitle,
  fullTitle: project.fullTitle,
  researchUnits: researchUnits.map(toResearchUnitDataset),
  thematics: project.thematics,
  startDate: toReadableDate(project.startDate),
  endDate: toReadableDate(project.endDate),
  description: project.description,
  url: project.url,
  referent: `${project.referent.firstName} ${project.referent.lastName}`,
  missions: project.missions.map(mission => MISSION_TEXT[mission]),
  partners: [...project.frenchPartners, ...project.foreignPartners].join(', '),
  funders: project.funders.join(', '),
});
